import { Fragment, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import ResCard from "../SubComponents/ResCard";
import { useParams } from "react-router-dom";
import Slider from "react-slick";

import MHSubscribe from "../../Layout/MHSubscribe";
import MHFooter from "../../Layout/MHFooter";

import { ReactComponent as Instagram } from "../../../static/svg/instagram.svg";
import { ReactComponent as Facebook } from "../../../static/svg/facebook.svg";
import { ReactComponent as Pinterest } from "../../../static/svg/pinterest.svg";
import { ReactComponent as Twitter } from "../../../static/svg/twitter.svg";
import VideoHeader from "../Videos/VideoHeader";
import AnimatedLoaderText from "../../Common/Loading/AnimatedLoaderText";
import { ResourcesData } from "../../NewLanding/EventGlance";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import dayjs from "dayjs";

const ViewPastEvent = () => {
  const [summitData, setSummitData] = useState<ResourcesData | null>(null); // ← fix
  const [summitPastData, setSummitPastData] = useState<ResourcesData[]>([]); // ← fix

  const slice = summitPastData.slice(0, 3);

  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    const getPodcast = async () => {
      try {
        const collectionRef = collection(db, "caf-past-summit");
        const querySnapshot = await getDocs(
          query(collectionRef, where("slug", "==", slug)),
        );

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setSummitData(doc.data() as ResourcesData);
        }
      } catch (error) {
        console.error("Error fetching podcast:", error);
      }
    };

    if (slug) getPodcast();
  }, [slug]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const collectionRef = collection(db, "caf-past-summit");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));

        setSummitPastData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const settings = {
    centerMode: true,
    centerPadding: "38px",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: false,
    // autoplaySpeed: 1500,
    // beforeChange: (current, next) => setSlideIndex(next),
  };

  // console.log("object", summitData?.link);

  if (!summitData)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <Fragment>
      <VideoHeader
        title={summitData?.title}
        description={summitData?.caption}
        imageUrl={summitData?.imgSrc}
        category={[]}
        categoryOne={summitData?.date}
        venue={summitData?.venue}
        downloadClassName="hidden flex -ml-4 my-6"
      />
      <Box className="md:px-20 p-4 lg:px-60 md:py-10 bg-white">
        <Box>
          <iframe
            // src="https://player.vimeo.com/video/819795726?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            src={summitData?.link}
            title={summitData?.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-[400px]  md:p-0 md:h-[400px] lg:h-[700px]"
          ></iframe>
        </Box>

        <Box className="block mb-12 -mt-12 md:mb-0 md:mt-4">
          <Box className="flex gap-4 text-center place-content-center">
            <a
              className="cursor-pointer"
              href="https://instagram.com/mhworklife?igshid=YmMyMTA2M2Y="
              target="_blanc"
              title="Visit our socials"
            >
              <Instagram />
            </a>
            <a
              className="cursor-pointer"
              href="https://www.facebook.com/motherhonestly?mibextid=LQQJ4d"
              target="_blanc"
              title="Visit our socials"
            >
              <Facebook />
            </a>
            <a
              className="cursor-pointer"
              href="https://www.pinterest.com/motherhonestly/"
              target="_blanc"
              title="Visit our socials"
            >
              <Pinterest />
            </a>
            <a
              className="cursor-pointer"
              href="https://twitter.com/mhworklife?s=21&t=lhmzHgRp7adyrrMjPPyrsw"
              target="_blanc"
              title="Visit our socials"
            >
              <Twitter />
            </a>
          </Box>
        </Box>
      </Box>

      <Box className="px-4 w-full md:px-20 lg:px-64 pb-6 bg-white">
        <Box className="">
          <Box className="flex text-justify">
            {/* Content */}
            <div
              dangerouslySetInnerHTML={{ __html: summitData?.description }}
            />
          </Box>
        </Box>
      </Box>
      <Box className="mx-auto block md:hidden pt-10 bg-white px-20 py-4">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-4"
        >
          Past Events You Might like
        </Typography>
      </Box>
      {/* For Mobile */}
      <Box className="block md:hidden bg-mhbluish overflow-x-hidden">
        <Slider {...settings}>
          {slice.map((res, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <ResCard
                cardClass="relative mb-10 w-[305px] h-[452px] object-cover bg-cream-100 rounded-md"
                iconClass="absolute top-14 left-[38%] mt-12 w-20 h-20"
                imgBg="bg-sky-400 h-[305px]"
                bodyBg="bg-cream-100"
                top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                imageSrc={res.imgSrc}
                podTop="hidden"
                title={res.title}
                venue={res.venue}
                eventType={res.eventType}
                titleUrl={`/events/past/${res.slug}`}
                playUrl={`/events/past/${res.slug}`}
              />
            </Grid>
          ))}
        </Slider>
      </Box>

      {/* For Web  */}
      <Box className="mx-auto pt-10 hidden md:block bg-white px-20 py-4">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-4"
        >
          Past Events You Might like
        </Typography>
        <Grid
          container
          spacing={2}
          className=" place-content-center place-items-center"
        >
          {slice.map((res, index) => (
            <Grid item xs={12} sm={6} md={3} lg={3} key={res.slug}>
              <ResCard
                cardClass="relative mb-10 w-[305px] h-[452px] object-cover bg-cream-100 rounded-md"
                iconClass="absolute top-14 left-[38%] mt-12 w-20 h-20"
                imgBg="bg-sky-400 h-[305px]"
                bodyBg="bg-cream-100"
                top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                imageSrc={res.imgSrc}
                podTop="hidden"
                title={res.title}
                venue={res.venue}
                eventType={res.eventType}
                titleUrl={`/events/past/${res.slug}`}
                playUrl={`/events/past/${res.slug}`}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <MHSubscribe />
      <MHFooter />
    </Fragment>
  );
};

export default ViewPastEvent;
